var flashcardSettings = require('./flashcard_settings');
var flashcardResults = require('./flashcard_results');
var chart = require('./flashcard_review_chart');

var ResultsModal = function(global) {

    var modalDiv = $('#'+ global.modal);

    var modalcontentstr = '<div class="modal-header">Create Flashcards</div><div class="modal-body feedback">' +
        '<div class="results-table-wrapper"></div>' +
        '</div><div class="modal-footer"><button type="button" class="btn btn-default" id="done-button">Done</button></div>';
    var modalContent = $.parseHTML(modalcontentstr);

    $(modalDiv).find('.modal-content').html('');

    $(modalDiv).find('.modal-content').append(modalContent);



    $('#done-button').click(function() {
        document.location.href = dashboardLink;
    });


    var tableWrapper = $(modalContent).find('.results-table-wrapper');
    var results = flashcardResults(global);
    tableWrapper.append(results);

    $(modalDiv).modal();

    var data = { viewed:global.viewed, unseen: global.unseen};

    var canv = $(modalContent).find('canvas')[0];

    chart(canv,data);

}

module.exports = ResultsModal;


//////////////////
// WEBPACK FOOTER
// ./src/flashcard_results_modal.js
// module id = 311
// module chunks = 0